import React, { useEffect, useState } from 'react';
import i18n from 'i18n-react';

import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const ALLOWED_COUNTRIES = ['gb', 'de', 'fr', 'au']; // List of allowed countries

const RewardMenu = () => {
  const [button, setButton] = useState('');
  const [isAllowed, setIsAllowed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkCountry = async () => {
      const langData = await StorageHandler.load(storageKeys.lang);
      const countryCode = langData?.code?.toLowerCase();
      setIsAllowed(ALLOWED_COUNTRIES.includes(countryCode));
    };

    // Check for mobile parameter
    const urlParams = new URLSearchParams(window.location.search);
    setIsMobile(urlParams.get('mobile') === 'true');

    checkCountry();
  }, []);

  useEffect(() => {
    if (!button) {
      setButton(window.location.pathname.split('/').slice(-1).pop());
    }
  }, [button]);

  // Helper function to get the link with mobile parameter if needed
  const getLinkPath = (path) => {
    return isMobile ? `${path}?mobile=true` : path;
  };

  return (
    <div className="rewards-nav">
      <div className="buttons">
        <Link to={getLinkPath('/main/rewards')}>
          <button type="button" value="" className={button === 'rewards' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'home']} />
            {i18n.translate('rewards.menu.home')}
          </button>
        </Link>
        <Link to={getLinkPath('/main/rewards/achievements')}>
          <button type="button" value="achievements" className={button === 'achievements' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'bars']} />
            {i18n.translate('rewards.menu.achievements')}
          </button>
        </Link>

        {/* Show these menu only if the selected country is allowed */}
        {isAllowed && (
          <>
            <Link to={getLinkPath('/main/rewards/bookings')}>
              <button type="button" value="booking" className={button === 'bookings' ? 'active btn' : 'btn'}>
                <FontAwesomeIcon icon={['far', 'badge']} />
                {i18n.translate('rewards.menu.bookings')}
              </button>
            </Link>
            <Link to={getLinkPath('/main/rewards/form')}>
              <button type="button" value="form" className={button === 'form' ? 'active btn' : 'btn'}>
                <FontAwesomeIcon icon={['fas', 'upload']} />
                {i18n.translate('rewards.menu.form')}
              </button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default RewardMenu;
